import React from 'react';

const TermsOfService = () => {
    // Şahıs Geliştirici Bilgileri: Kendi Adınız ve E-posta Adresinizle DOLDURUN
    const developerName = "[Adınız Soyadınız]"; 
    const lastUpdated = "12 Aralık 2025"; // Bugünün Tarihi

    return (
        <div className="min-h-screen p-6 md:p-12 lg:p-20 text-white bg-slate-900">
            <div className="max-w-5xl mx-auto bg-slate-800 p-8 rounded-lg shadow-2xl">
                <h1 className="text-4xl md:text-5xl font-extrabold mb-4 text-green-400 border-b-2 border-green-400 pb-3">
                    Axiowar Kullanım Şartları
                </h1>
                <p className="text-sm mb-10 text-slate-400">
                    Son Güncelleme: {lastUpdated}
                </p>

                <p className="mb-6 text-slate-300">
                    Axiowar oyununu (`axiowar.azizgiorgi.com`) kullanarak, bu Kullanım Şartlarına uymayı kabul etmiş olursunuz.
                </p>

                <h2 className="text-2xl font-semibold mt-10 mb-4 text-green-300">1. Fikri Mülkiyet</h2>
                <p className="mb-4 text-slate-300">
                    Oyunun kendisi (kod, grafikler, sesler ve diğer içerikler) {developerName}'a aittir ve telif hakları ile korunmaktadır. Oyunun içeriği, ticari olmayan kişisel kullanımınız için size lisanslanmıştır.
                </p>

                <h2 className="text-2xl font-semibold mt-10 mb-4 text-green-300">2. Kabul Edilebilir Kullanım</h2>
                <ul className="list-disc list-inside space-y-3 ml-4 text-slate-300">
                    <li>Hile, bot veya otomasyon araçları kullanmak kesinlikle yasaktır.</li>
                    <li>Diğer oyunculara karşı taciz edici veya nefret dolu davranışlarda bulunmak yasaktır.</li>
                    <li>Oyun hizmetini aksatacak, bozacak veya aşırı yükleyecek eylemlerde bulunmak yasaktır.</li>
                </ul>

                <h2 className="text-2xl font-semibold mt-10 mb-4 text-green-300">3. Sorumluluğun Reddi</h2>
                <p className="mb-4 text-slate-300">
                    Oyun "olduğu gibi" sunulmaktadır. Oyunun kesintisiz, hatasız veya virüssüz olacağına dair herhangi bir garanti vermeyiz. Oyunun sadece masaüstü bilgisayarlar ve laptoplar için optimize edildiğini ve mobil cihazlarda düzgün çalışmayabileceğini kabul edersiniz.
                </p>
                
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-green-300">4. Şartların İhlali</h2>
                <p className="text-slate-300">
                    Bu şartlardan herhangi birini ihlal etmeniz durumunda, hesabınızı bildirimde bulunmaksızın derhal feshetme hakkını saklı tutma hakkını saklı tutarız.
                </p>
            </div>
        </div>
    );
};

export default TermsOfService;